import React, { Component } from 'react'

export default class Link extends Component {
  onClick(event) {
    event.preventDefault()
    this.props.onClick()
    window.history.pushState(null, null, this.props.to)
    window.dispatchEvent(new window.PopStateEvent('popstate'))
  }

  render() {
    return (
      <a
        className={this.props.className}
        href={this.props.to}
        onClick={this.onClick.bind(this)}
      >
        {this.props.children}
      </a>
    )
  }
}



// WEBPACK FOOTER //
// ./src/front/components/Link.js